import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';

export const selectMfePersonalInfoClientState = createSelector(
  fromFeature.getMfePersonalInfoClientState,
  (state) => state,
);

export const selectMfePersonalInfoClientIsLoaded = createSelector(
  selectMfePersonalInfoClientState,
  (state) => state.isLoaded,
);

export const selectMfePersonalInfoClientPersonalInfo = createSelector(
  selectMfePersonalInfoClientState,
  (state) => state.personalInfo,
);

export const selectMfePersonalInfoClientIsInformationCorrect = createSelector(
  selectMfePersonalInfoClientState,
  (state) => state.isInformationCorrect,
);

export const selectMfePersonalInfoClientSSN = createSelector(
  selectMfePersonalInfoClientPersonalInfo,
  (personalInfo) => personalInfo?.ssn ?? '',
);
